/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PagedProductSearchResultDto } from '../models/paged-product-search-result-dto';
import { ProductDto } from '../models/product-dto';
import { ProductSourceEnum } from '../models/product-source-enum';

@Injectable({
  providedIn: 'root',
})
export class ProductService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation searchProductsPaged
   */
  static readonly SearchProductsPagedPath = '/products';

  /**
   * Search for products.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchProductsPaged()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchProductsPaged$Response(params: {
    search?: string;
    source?: ProductSourceEnum;
    pageIndex?: number;
    pageSize: number;
  }): Observable<StrictHttpResponse<PagedProductSearchResultDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.SearchProductsPagedPath, 'get');
    if (params) {
      rb.query('search', params.search, {});
      rb.query('source', params.source, {});
      rb.query('pageIndex', params.pageIndex, {});
      rb.query('pageSize', params.pageSize, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedProductSearchResultDto>;
      })
    );
  }

  /**
   * Search for products.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `searchProductsPaged$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchProductsPaged(params: {
    search?: string;
    source?: ProductSourceEnum;
    pageIndex?: number;
    pageSize: number;
  }): Observable<PagedProductSearchResultDto> {

    return this.searchProductsPaged$Response(params).pipe(
      map((r: StrictHttpResponse<PagedProductSearchResultDto>) => r.body as PagedProductSearchResultDto)
    );
  }

  /**
   * Path part for operation createProduct
   */
  static readonly CreateProductPath = '/products';

  /**
   * Add Product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProduct$Response(params: {
    body: ProductDto
  }): Observable<StrictHttpResponse<ProductDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.CreateProductPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductDto>;
      })
    );
  }

  /**
   * Add Product.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProduct(params: {
    body: ProductDto
  }): Observable<ProductDto> {

    return this.createProduct$Response(params).pipe(
      map((r: StrictHttpResponse<ProductDto>) => r.body as ProductDto)
    );
  }

  /**
   * Path part for operation getProduct
   */
  static readonly GetProductPath = '/products/{productId}';

  /**
   * Get Product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProduct$Response(params: {
    productId: string;
  }): Observable<StrictHttpResponse<ProductDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.GetProductPath, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductDto>;
      })
    );
  }

  /**
   * Get Product.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProduct(params: {
    productId: string;
  }): Observable<ProductDto> {

    return this.getProduct$Response(params).pipe(
      map((r: StrictHttpResponse<ProductDto>) => r.body as ProductDto)
    );
  }

  /**
   * Path part for operation updateProduct
   */
  static readonly UpdateProductPath = '/products/{productId}';

  /**
   * Update Product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProduct$Response(params: {
    productId: string;
    body: ProductDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.UpdateProductPath, 'put');
    if (params) {
      rb.path('productId', params.productId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Update Product.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProduct(params: {
    productId: string;
    body: ProductDto
  }): Observable<void> {

    return this.updateProduct$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getProductMatch
   */
  static readonly GetProductMatchPath = '/products/{productId}/match';

  /**
   * Get Product Match.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductMatch()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMatch$Response(params: {
    productId: string;
  }): Observable<StrictHttpResponse<ProductDto>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.GetProductMatchPath, 'get');
    if (params) {
      rb.path('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductDto>;
      })
    );
  }

  /**
   * Get Product Match.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductMatch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductMatch(params: {
    productId: string;
  }): Observable<ProductDto> {

    return this.getProductMatch$Response(params).pipe(
      map((r: StrictHttpResponse<ProductDto>) => r.body as ProductDto)
    );
  }

  /**
   * Path part for operation setProductMatch
   */
  static readonly SetProductMatchPath = '/products/{productId}/match/{matchedProductId}';

  /**
   * Set Product Match.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setProductMatch()` instead.
   *
   * This method doesn't expect any request body.
   */
  setProductMatch$Response(params: {
    productId: string;
    matchedProductId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.SetProductMatchPath, 'put');
    if (params) {
      rb.path('productId', params.productId, {});
      rb.path('matchedProductId', params.matchedProductId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Set Product Match.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setProductMatch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setProductMatch(params: {
    productId: string;
    matchedProductId: string;
  }): Observable<void> {

    return this.setProductMatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation disableProductMatch
   */
  static readonly DisableProductMatchPath = '/products/{productId}/match/{matchedProductId}';

  /**
   * Disable Product Match.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disableProductMatch()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableProductMatch$Response(params: {
    productId: string;
    matchedProductId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.DisableProductMatchPath, 'delete');
    if (params) {
      rb.path('productId', params.productId, {});
      rb.path('matchedProductId', params.matchedProductId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Disable Product Match.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `disableProductMatch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableProductMatch(params: {
    productId: string;
    matchedProductId: string;
  }): Observable<void> {

    return this.disableProductMatch$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation disableProduct
   */
  static readonly DisableProductPath = '/products/{productId}/disable';

  /**
   * Disable Product.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disableProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableProduct$Response(params: {
    productId: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ProductService.DisableProductPath, 'post');
    if (params) {
      rb.path('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Disable Product.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `disableProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableProduct(params: {
    productId: string;
  }): Observable<void> {

    return this.disableProduct$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
